// tslint:disable
/**
 * MoeAuthProxy
 * Moe auth proxy
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    hnr?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    validity?: string;
}
/**
 * 
 * @export
 * @interface ApiResponseBody
 */
export interface ApiResponseBody {
    /**
     * 
     * @type {string}
     * @memberof ApiResponseBody
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseBody
     */
    message: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiResponseBody
     */
    errors: Array<string>;
}
/**
 * 
 * @export
 * @interface AuthenticationV1Identity
 */
export interface AuthenticationV1Identity {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationV1Identity
     */
    identityKey: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationV1Identity
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationV1Identity
     */
    emailStatus: AuthenticationV1IdentityEmailStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AuthenticationV1IdentityEmailStatusEnum {
    Verified = 'verified',
    Unreachable = 'unreachable',
    Unknown = 'unknown'
}

/**
 * 
 * @export
 * @interface BasicAuth
 */
export interface BasicAuth {
    /**
     * 
     * @type {string}
     * @memberof BasicAuth
     */
    authorization: string;
}
/**
 * 
 * @export
 * @interface BodyData
 */
export interface BodyData {
    /**
     * 
     * @type {UserData}
     * @memberof BodyData
     */
    user?: UserData;
}
/**
 * 
 * @export
 * @interface DemographicData
 */
export interface DemographicData {
    /**
     * 
     * @type {string}
     * @memberof DemographicData
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof DemographicData
     */
    age?: string;
}
/**
 * 
 * @export
 * @interface Email
 */
export interface Email {
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    validity?: string;
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    adPermission?: string;
}
/**
 * 
 * @export
 * @interface Employment
 */
export interface Employment {
    /**
     * 
     * @type {boolean}
     * @memberof Employment
     */
    active?: boolean;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    message?: string;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ErrorResponse
     */
    errors?: Array<Error>;
}
/**
 * 
 * @export
 * @interface HeaderResponseData
 */
export interface HeaderResponseData {
    /**
     * 
     * @type {number}
     * @memberof HeaderResponseData
     */
    statusCode?: number;
    /**
     * 
     * @type {string}
     * @memberof HeaderResponseData
     */
    ssoId?: string;
}
/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * cknr or email of the um2 user
     * @type {string}
     * @memberof LoginRequest
     */
    user?: string;
    /**
     * password of the um2 user
     * @type {string}
     * @memberof LoginRequest
     */
    password?: string;
}
/**
 * 
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse {
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    access_token?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    refresh_token?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    scope?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    token_type?: string;
    /**
     * 
     * @type {number}
     * @memberof LoginResponse
     */
    expires_in?: number;
}
/**
 * 
 * @export
 * @interface Membership
 */
export interface Membership {
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    joinDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    leaveDate?: string;
    /**
     * 
     * @type {Services}
     * @memberof Membership
     */
    services?: Services;
    /**
     * 
     * @type {boolean}
     * @memberof Membership
     */
    paid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    category?: string;
    /**
     * 
     * @type {number}
     * @memberof Membership
     */
    lv?: number;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    contractGroup?: string;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface Phone
 */
export interface Phone {
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    adPermission?: string;
}
/**
 * 
 * @export
 * @interface PortalApiUser
 */
export interface PortalApiUser {
    /**
     * 
     * @type {number}
     * @memberof PortalApiUser
     */
    pnr?: number;
    /**
     * 
     * @type {string}
     * @memberof PortalApiUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalApiUser
     */
    firstname?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalApiUser
     */
    lastname?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalApiUser
     */
    title?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortalApiUser
     */
    isCompany?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortalApiUser
     */
    isMember?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortalApiUser
     */
    isEmployee?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortalApiUser
     */
    hasPaid?: boolean;
    /**
     * 
     * @type {PortalApiUserTrackingCodes}
     * @memberof PortalApiUser
     */
    trackingCodes?: PortalApiUserTrackingCodes;
    /**
     * 
     * @type {string}
     * @memberof PortalApiUser
     */
    sessionId?: string;
}
/**
 * 
 * @export
 * @interface PortalApiUserTrackingCodes
 */
export interface PortalApiUserTrackingCodes {
    /**
     * 
     * @type {PortalApiUserTrackingCodesUserType}
     * @memberof PortalApiUserTrackingCodes
     */
    userType?: PortalApiUserTrackingCodesUserType;
    /**
     * 
     * @type {PortalApiUserTrackingCodesDemographicData}
     * @memberof PortalApiUserTrackingCodes
     */
    demographicData?: PortalApiUserTrackingCodesDemographicData;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortalApiUserTrackingCodes
     */
    insuranceData?: Array<string>;
}
/**
 * 
 * @export
 * @interface PortalApiUserTrackingCodesDemographicData
 */
export interface PortalApiUserTrackingCodesDemographicData {
    /**
     * 
     * @type {string}
     * @memberof PortalApiUserTrackingCodesDemographicData
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalApiUserTrackingCodesDemographicData
     */
    age?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalApiUserTrackingCodesDemographicData
     */
    relation?: string;
    /**
     * 
     * @type {number}
     * @memberof PortalApiUserTrackingCodesDemographicData
     */
    landesverein?: number;
}
/**
 * 
 * @export
 * @interface PortalApiUserTrackingCodesUserType
 */
export interface PortalApiUserTrackingCodesUserType {
    /**
     * 
     * @type {string}
     * @memberof PortalApiUserTrackingCodesUserType
     */
    memberStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalApiUserTrackingCodesUserType
     */
    memberType?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalApiUserTrackingCodesUserType
     */
    sbStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalApiUserTrackingCodesUserType
     */
    kkStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalApiUserTrackingCodesUserType
     */
    payType?: string;
}
/**
 * 
 * @export
 * @interface Services
 */
export interface Services {
    /**
     * 
     * @type {boolean}
     * @memberof Services
     */
    sb?: boolean;
    /**
     * 
     * @type {object}
     * @memberof Services
     */
    creditcard?: object;
    /**
     * 
     * @type {object}
     * @memberof Services
     */
    eev?: object;
    /**
     * 
     * @type {object}
     * @memberof Services
     */
    wrks?: object;
}
/**
 * 
 * @export
 * @interface SessionsResponse
 */
export interface SessionsResponse {
    /**
     * 
     * @type {string}
     * @memberof SessionsResponse
     */
    identityKey?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionsResponse
     */
    sessionToken?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionsResponse
     */
    startTime?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionsResponse
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionsResponse
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionsResponse
     */
    accessToken?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionsResponse
     */
    refreshToken?: string;
}
/**
 * 
 * @export
 * @interface TokenRequest
 */
export interface TokenRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    redirectUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    refreshToken?: string;
}
/**
 * 
 * @export
 * @interface TrackingCodes
 */
export interface TrackingCodes {
    /**
     * 
     * @type {UserType}
     * @memberof TrackingCodes
     */
    userType?: UserType;
    /**
     * 
     * @type {DemographicData}
     * @memberof TrackingCodes
     */
    demographicData?: DemographicData;
}
/**
 * 
 * @export
 * @interface UmResponse
 */
export interface UmResponse {
    /**
     * 
     * @type {HeaderResponseData}
     * @memberof UmResponse
     */
    header?: HeaderResponseData;
    /**
     * 
     * @type {BodyData}
     * @memberof UmResponse
     */
    body?: BodyData;
}
/**
 * 
 * @export
 * @interface UserData
 */
export interface UserData {
    /**
     * 
     * @type {Email}
     * @memberof UserData
     */
    email?: Email;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    emailNew?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    clubEmailPermission?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    hashId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    firstname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    lastname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    salutation?: string;
    /**
     * 
     * @type {Phone}
     * @memberof UserData
     */
    phone?: Phone;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    birthdate?: string;
    /**
     * 
     * @type {Address}
     * @memberof UserData
     */
    address?: Address;
    /**
     * 
     * @type {Membership}
     * @memberof UserData
     */
    membership?: Membership;
    /**
     * 
     * @type {Employment}
     * @memberof UserData
     */
    employment?: Employment;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    advertisementInfo?: string;
    /**
     * 
     * @type {TrackingCodes}
     * @memberof UserData
     */
    trackingCodes?: TrackingCodes;
    /**
     * 
     * @type {number}
     * @memberof UserData
     */
    userid?: number;
    /**
     * 
     * @type {number}
     * @memberof UserData
     */
    pnr?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserData
     */
    active?: boolean;
}
/**
 * 
 * @export
 * @interface UserType
 */
export interface UserType {
    /**
     * 
     * @type {string}
     * @memberof UserType
     */
    memberStatus?: string;
}
/**
 * 
 * @export
 * @interface UsersV1Address
 */
export interface UsersV1Address {
    /**
     * 
     * @type {string}
     * @memberof UsersV1Address
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersV1Address
     */
    streetNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersV1Address
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersV1Address
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersV1Address
     */
    country?: string;
}
/**
 * 
 * @export
 * @interface UsersV1Identity
 */
export interface UsersV1Identity {
    /**
     * 
     * @type {string}
     * @memberof UsersV1Identity
     */
    identityKey: string;
    /**
     * 
     * @type {string}
     * @memberof UsersV1Identity
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UsersV1Identity
     */
    emailStatus: UsersV1IdentityEmailStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UsersV1IdentityEmailStatusEnum {
    Verified = 'verified',
    Unreachable = 'unreachable',
    Unknown = 'unknown'
}

/**
 * 
 * @export
 * @interface UsersV1OeamtcMembership
 */
export interface UsersV1OeamtcMembership {
    /**
     * 
     * @type {number}
     * @memberof UsersV1OeamtcMembership
     */
    cknr: number;
    /**
     * 
     * @type {string}
     * @memberof UsersV1OeamtcMembership
     */
    membershipStatus?: UsersV1OeamtcMembershipMembershipStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UsersV1OeamtcMembership
     */
    membershipCategory?: string;
    /**
     * 
     * @type {object}
     * @memberof UsersV1OeamtcMembership
     */
    membershipLv?: object;
    /**
     * 
     * @type {string}
     * @memberof UsersV1OeamtcMembership
     */
    membershipJoinDate?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UsersV1OeamtcMembershipMembershipStatusEnum {
    Active = 'active',
    Inactive = 'inactive'
}

/**
 * 
 * @export
 * @interface UsersV1User
 */
export interface UsersV1User {
    /**
     * 
     * @type {UsersV1Identity}
     * @memberof UsersV1User
     */
    identity: UsersV1Identity;
    /**
     * 
     * @type {number}
     * @memberof UsersV1User
     */
    userId: number;
    /**
     * 
     * @type {UsersV1OeamtcMembership}
     * @memberof UsersV1User
     */
    oeamtcMembership?: UsersV1OeamtcMembership;
    /**
     * 
     * @type {string}
     * @memberof UsersV1User
     */
    academicTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersV1User
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersV1User
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersV1User
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersV1User
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersV1User
     */
    phone?: string;
    /**
     * 
     * @type {UsersV1Address}
     * @memberof UsersV1User
     */
    address?: UsersV1Address;
    /**
     * 
     * @type {string}
     * @memberof UsersV1User
     */
    dateOfBirth?: string;
    /**
     * 
     * @type {string}
     * @memberof UsersV1User
     */
    emailMarketingPermissionStatus?: UsersV1UserEmailMarketingPermissionStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UsersV1UserEmailMarketingPermissionStatusEnum {
    Unknown = 'unknown',
    Granted = 'granted',
    Revoked = 'revoked',
    Unconfirmed = 'unconfirmed'
}


/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * generate an access- and refreshToken for an authorization code
         * @param {TokenRequest} tokenRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateToken: async (tokenRequestBody: TokenRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenRequestBody' is not null or undefined
            if (tokenRequestBody === null || tokenRequestBody === undefined) {
                throw new RequiredError('tokenRequestBody','Required parameter tokenRequestBody was null or undefined when calling generateToken.');
            }
            const localVarPath = `/token`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof tokenRequestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(tokenRequestBody !== undefined ? tokenRequestBody : {}) : (tokenRequestBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginRequest} loginRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequestBody: LoginRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequestBody' is not null or undefined
            if (loginRequestBody === null || loginRequestBody === undefined) {
                throw new RequiredError('loginRequestBody','Required parameter loginRequestBody was null or undefined when calling login.');
            }
            const localVarPath = `/login`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof loginRequestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(loginRequestBody !== undefined ? loginRequestBody : {}) : (loginRequestBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * logout given access token and dismiss accessToken, refreshToken, ssoId and refreshToken cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/revoke`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * generate an access- and refreshToken for an authorization code
         * @param {TokenRequest} tokenRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateToken(tokenRequestBody: TokenRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AuthenticationApiAxiosParamCreator(configuration).generateToken(tokenRequestBody, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {LoginRequest} loginRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequestBody: LoginRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await AuthenticationApiAxiosParamCreator(configuration).login(loginRequestBody, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * logout given access token and dismiss accessToken, refreshToken, ssoId and refreshToken cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AuthenticationApiAxiosParamCreator(configuration).logout(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * generate an access- and refreshToken for an authorization code
         * @param {TokenRequest} tokenRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateToken(tokenRequestBody: TokenRequest, options?: any): AxiosPromise<void> {
            return AuthenticationApiFp(configuration).generateToken(tokenRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginRequest} loginRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequestBody: LoginRequest, options?: any): AxiosPromise<LoginResponse> {
            return AuthenticationApiFp(configuration).login(loginRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * logout given access token and dismiss accessToken, refreshToken, ssoId and refreshToken cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): AxiosPromise<void> {
            return AuthenticationApiFp(configuration).logout(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * generate an access- and refreshToken for an authorization code
     * @param {TokenRequest} tokenRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public generateToken(tokenRequestBody: TokenRequest, options?: any) {
        return AuthenticationApiFp(this.configuration).generateToken(tokenRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginRequest} loginRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public login(loginRequestBody: LoginRequest, options?: any) {
        return AuthenticationApiFp(this.configuration).login(loginRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * logout given access token and dismiss accessToken, refreshToken, ssoId and refreshToken cookie
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public logout(options?: any) {
        return AuthenticationApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EasywayApi - axios parameter creator
 * @export
 */
export const EasywayApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Verify wether the user is permitted to use easyway
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verify: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/easyway/verify`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EasywayApi - functional programming interface
 * @export
 */
export const EasywayApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Verify wether the user is permitted to use easyway
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verify(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await EasywayApiAxiosParamCreator(configuration).verify(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EasywayApi - factory interface
 * @export
 */
export const EasywayApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Verify wether the user is permitted to use easyway
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verify(options?: any): AxiosPromise<void> {
            return EasywayApiFp(configuration).verify(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EasywayApi - object-oriented interface
 * @export
 * @class EasywayApi
 * @extends {BaseAPI}
 */
export class EasywayApi extends BaseAPI {
    /**
     * Verify wether the user is permitted to use easyway
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EasywayApi
     */
    public verify(options?: any) {
        return EasywayApiFp(this.configuration).verify(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * LegacyApi - axios parameter creator
 * @export
 */
export const LegacyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Read user by identityKey
         * @summary Read user by identityKey
         * @param {string} identityKey UUID of a user\&#39;s identity
         * @param {string} xIdentityManagementTenant The clients tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByIdentityKey: async (identityKey: string, xIdentityManagementTenant: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityKey' is not null or undefined
            if (identityKey === null || identityKey === undefined) {
                throw new RequiredError('identityKey','Required parameter identityKey was null or undefined when calling getUserByIdentityKey.');
            }
            // verify required parameter 'xIdentityManagementTenant' is not null or undefined
            if (xIdentityManagementTenant === null || xIdentityManagementTenant === undefined) {
                throw new RequiredError('xIdentityManagementTenant','Required parameter xIdentityManagementTenant was null or undefined when calling getUserByIdentityKey.');
            }
            const localVarPath = `/legacy/api/selfservice/v1/users/{identityKey}`
                .replace(`{${"identityKey"}}`, encodeURIComponent(String(identityKey)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xIdentityManagementTenant !== undefined && xIdentityManagementTenant !== null) {
                localVarHeaderParameter['X-IdentityManagement-Tenant'] = String(xIdentityManagementTenant);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a user by ssoId
         * @summary Get a user by ssoId
         * @param {string} ssoId ssoId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBySsoId: async (ssoId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ssoId' is not null or undefined
            if (ssoId === null || ssoId === undefined) {
                throw new RequiredError('ssoId','Required parameter ssoId was null or undefined when calling getUserBySsoId.');
            }
            const localVarPath = `/legacy/api/legacy/v1/sessions/{ssoId}/user`
                .replace(`{${"ssoId"}}`, encodeURIComponent(String(ssoId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create session for an identity
         * @summary Create session
         * @param {string} authorization Base64 encoded credentials, e.g. \&#39;Basic aGVybWFubkBncmFmLmF0OnRlc3R0ZXN0\&#39; or token based authentication with appropriate UUID, e.g. \&#39;Token e7372c59-b1e6-4fcd-b5c3-ac4321591b88\&#39;
         * @param {string} [xIdentityManagementTenant] The clients tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyCreateSession: async (authorization: string, xIdentityManagementTenant?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            if (authorization === null || authorization === undefined) {
                throw new RequiredError('authorization','Required parameter authorization was null or undefined when calling legacyCreateSession.');
            }
            const localVarPath = `/legacy/api/identity/v1/sessions`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xIdentityManagementTenant !== undefined && xIdentityManagementTenant !== null) {
                localVarHeaderParameter['X-IdentityManagement-Tenant'] = String(xIdentityManagementTenant);
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create session for an identity
         * @summary Create session
         * @param {BasicAuth} authorization Base64 encoded credentials, e.g. \&#39;Basic aGVybWFubkBncmFmLmF0OnRlc3R0ZXN0\&#39; or token based authentication with appropriate UUID, e.g. \&#39;Token e7372c59-b1e6-4fcd-b5c3-ac4321591b88\&#39;
         * @param {string} [xIdentityManagementTenant] The clients tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyCreateSessionV2: async (authorization: BasicAuth, xIdentityManagementTenant?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            if (authorization === null || authorization === undefined) {
                throw new RequiredError('authorization','Required parameter authorization was null or undefined when calling legacyCreateSessionV2.');
            }
            const localVarPath = `/legacy/api/identity/v2/sessions`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xIdentityManagementTenant !== undefined && xIdentityManagementTenant !== null) {
                localVarHeaderParameter['X-IdentityManagement-Tenant'] = String(xIdentityManagementTenant);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof authorization !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(authorization !== undefined ? authorization : {}) : (authorization || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete session of an identity
         * @summary Delete session
         * @param {string} sessionToken UUID of session
         * @param {string} [xIdentityManagementTenant] The clients tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyDeleteSession: async (sessionToken: string, xIdentityManagementTenant?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionToken' is not null or undefined
            if (sessionToken === null || sessionToken === undefined) {
                throw new RequiredError('sessionToken','Required parameter sessionToken was null or undefined when calling legacyDeleteSession.');
            }
            const localVarPath = `/legacy/api/identity/v1/sessions/{sessionToken}`
                .replace(`{${"sessionToken"}}`, encodeURIComponent(String(sessionToken)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xIdentityManagementTenant !== undefined && xIdentityManagementTenant !== null) {
                localVarHeaderParameter['X-IdentityManagement-Tenant'] = String(xIdentityManagementTenant);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user data by ssoId
         * @summary Get user data by ssoId
         * @param {string} callback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyGetUser: async (callback: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'callback' is not null or undefined
            if (callback === null || callback === undefined) {
                throw new RequiredError('callback','Required parameter callback was null or undefined when calling legacyGetUser.');
            }
            const localVarPath = `/legacy/ext/user`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (callback !== undefined) {
                localVarQueryParameter['callback'] = callback;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user data by ssoId
         * @summary Get user data by ssoId
         * @param {string} callback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyGetUser2: async (callback: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'callback' is not null or undefined
            if (callback === null || callback === undefined) {
                throw new RequiredError('callback','Required parameter callback was null or undefined when calling legacyGetUser2.');
            }
            const localVarPath = `/legacy/ext/v2/user`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (callback !== undefined) {
                localVarQueryParameter['callback'] = callback;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user data by ssoId
         * @summary Get user data by ssoId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyGetUser3: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/legacy/ext/v3/user`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * performs login with credentials from header
         * @summary Login with given credentials
         * @param {string} authorization Base64 encoded credentials, e.g. \&#39;Basic aGVybWFubkBncmFmLmF0OnRlc3R0ZXN0\&#39; or token based authentication with appropriate UUID, e.g. \&#39;Token e7372c59-b1e6-4fcd-b5c3-ac4321591b88\&#39;
         * @param {boolean} [rememberMe] include rememberMeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyLogin: async (authorization: string, rememberMe?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            if (authorization === null || authorization === undefined) {
                throw new RequiredError('authorization','Required parameter authorization was null or undefined when calling legacyLogin.');
            }
            const localVarPath = `/legacy/ext/v2/login`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (rememberMe !== undefined) {
                localVarQueryParameter['rememberMe'] = rememberMe;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Logout by given ssoId
         * @summary Logout by given ssoId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyLogout: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/legacy/ext/logout`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read session from Identity Management
         * @summary Read session
         * @param {string} sessionToken UUID of session
         * @param {string} [xIdentityManagementTenant] The clients tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyReadSession: async (sessionToken: string, xIdentityManagementTenant?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionToken' is not null or undefined
            if (sessionToken === null || sessionToken === undefined) {
                throw new RequiredError('sessionToken','Required parameter sessionToken was null or undefined when calling legacyReadSession.');
            }
            const localVarPath = `/legacy/api/identity/v1/sessions/{sessionToken}`
                .replace(`{${"sessionToken"}}`, encodeURIComponent(String(sessionToken)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xIdentityManagementTenant !== undefined && xIdentityManagementTenant !== null) {
                localVarHeaderParameter['X-IdentityManagement-Tenant'] = String(xIdentityManagementTenant);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the cknr by ssoId
         * @summary Read session for cknr
         * @param {string} sessionToken UUID of session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyReadSessionPnr: async (sessionToken: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionToken' is not null or undefined
            if (sessionToken === null || sessionToken === undefined) {
                throw new RequiredError('sessionToken','Required parameter sessionToken was null or undefined when calling legacyReadSessionPnr.');
            }
            const localVarPath = `/legacy/api/legacy/v1/sessions/{sessionToken}/user/pnr`
                .replace(`{${"sessionToken"}}`, encodeURIComponent(String(sessionToken)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the userId by ssoId
         * @summary Read session for userId
         * @param {string} sessionToken UUID of session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyReadSessionUserId: async (sessionToken: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionToken' is not null or undefined
            if (sessionToken === null || sessionToken === undefined) {
                throw new RequiredError('sessionToken','Required parameter sessionToken was null or undefined when calling legacyReadSessionUserId.');
            }
            const localVarPath = `/legacy/api/legacy/v1/sessions/{sessionToken}/user/id`
                .replace(`{${"sessionToken"}}`, encodeURIComponent(String(sessionToken)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegacyApi - functional programming interface
 * @export
 */
export const LegacyApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Read user by identityKey
         * @summary Read user by identityKey
         * @param {string} identityKey UUID of a user\&#39;s identity
         * @param {string} xIdentityManagementTenant The clients tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserByIdentityKey(identityKey: string, xIdentityManagementTenant: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersV1User>> {
            const localVarAxiosArgs = await LegacyApiAxiosParamCreator(configuration).getUserByIdentityKey(identityKey, xIdentityManagementTenant, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a user by ssoId
         * @summary Get a user by ssoId
         * @param {string} ssoId ssoId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserBySsoId(ssoId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UmResponse>> {
            const localVarAxiosArgs = await LegacyApiAxiosParamCreator(configuration).getUserBySsoId(ssoId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create session for an identity
         * @summary Create session
         * @param {string} authorization Base64 encoded credentials, e.g. \&#39;Basic aGVybWFubkBncmFmLmF0OnRlc3R0ZXN0\&#39; or token based authentication with appropriate UUID, e.g. \&#39;Token e7372c59-b1e6-4fcd-b5c3-ac4321591b88\&#39;
         * @param {string} [xIdentityManagementTenant] The clients tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyCreateSession(authorization: string, xIdentityManagementTenant?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsResponse>> {
            const localVarAxiosArgs = await LegacyApiAxiosParamCreator(configuration).legacyCreateSession(authorization, xIdentityManagementTenant, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create session for an identity
         * @summary Create session
         * @param {BasicAuth} authorization Base64 encoded credentials, e.g. \&#39;Basic aGVybWFubkBncmFmLmF0OnRlc3R0ZXN0\&#39; or token based authentication with appropriate UUID, e.g. \&#39;Token e7372c59-b1e6-4fcd-b5c3-ac4321591b88\&#39;
         * @param {string} [xIdentityManagementTenant] The clients tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyCreateSessionV2(authorization: BasicAuth, xIdentityManagementTenant?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsResponse>> {
            const localVarAxiosArgs = await LegacyApiAxiosParamCreator(configuration).legacyCreateSessionV2(authorization, xIdentityManagementTenant, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete session of an identity
         * @summary Delete session
         * @param {string} sessionToken UUID of session
         * @param {string} [xIdentityManagementTenant] The clients tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyDeleteSession(sessionToken: string, xIdentityManagementTenant?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await LegacyApiAxiosParamCreator(configuration).legacyDeleteSession(sessionToken, xIdentityManagementTenant, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get user data by ssoId
         * @summary Get user data by ssoId
         * @param {string} callback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyGetUser(callback: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await LegacyApiAxiosParamCreator(configuration).legacyGetUser(callback, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get user data by ssoId
         * @summary Get user data by ssoId
         * @param {string} callback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyGetUser2(callback: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await LegacyApiAxiosParamCreator(configuration).legacyGetUser2(callback, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get user data by ssoId
         * @summary Get user data by ssoId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyGetUser3(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalApiUser>> {
            const localVarAxiosArgs = await LegacyApiAxiosParamCreator(configuration).legacyGetUser3(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * performs login with credentials from header
         * @summary Login with given credentials
         * @param {string} authorization Base64 encoded credentials, e.g. \&#39;Basic aGVybWFubkBncmFmLmF0OnRlc3R0ZXN0\&#39; or token based authentication with appropriate UUID, e.g. \&#39;Token e7372c59-b1e6-4fcd-b5c3-ac4321591b88\&#39;
         * @param {boolean} [rememberMe] include rememberMeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyLogin(authorization: string, rememberMe?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortalApiUser>> {
            const localVarAxiosArgs = await LegacyApiAxiosParamCreator(configuration).legacyLogin(authorization, rememberMe, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Logout by given ssoId
         * @summary Logout by given ssoId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyLogout(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await LegacyApiAxiosParamCreator(configuration).legacyLogout(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Read session from Identity Management
         * @summary Read session
         * @param {string} sessionToken UUID of session
         * @param {string} [xIdentityManagementTenant] The clients tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyReadSession(sessionToken: string, xIdentityManagementTenant?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsResponse>> {
            const localVarAxiosArgs = await LegacyApiAxiosParamCreator(configuration).legacyReadSession(sessionToken, xIdentityManagementTenant, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get the cknr by ssoId
         * @summary Read session for cknr
         * @param {string} sessionToken UUID of session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyReadSessionPnr(sessionToken: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await LegacyApiAxiosParamCreator(configuration).legacyReadSessionPnr(sessionToken, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get the userId by ssoId
         * @summary Read session for userId
         * @param {string} sessionToken UUID of session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legacyReadSessionUserId(sessionToken: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await LegacyApiAxiosParamCreator(configuration).legacyReadSessionUserId(sessionToken, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LegacyApi - factory interface
 * @export
 */
export const LegacyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Read user by identityKey
         * @summary Read user by identityKey
         * @param {string} identityKey UUID of a user\&#39;s identity
         * @param {string} xIdentityManagementTenant The clients tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByIdentityKey(identityKey: string, xIdentityManagementTenant: string, options?: any): AxiosPromise<UsersV1User> {
            return LegacyApiFp(configuration).getUserByIdentityKey(identityKey, xIdentityManagementTenant, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a user by ssoId
         * @summary Get a user by ssoId
         * @param {string} ssoId ssoId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBySsoId(ssoId: string, options?: any): AxiosPromise<UmResponse> {
            return LegacyApiFp(configuration).getUserBySsoId(ssoId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create session for an identity
         * @summary Create session
         * @param {string} authorization Base64 encoded credentials, e.g. \&#39;Basic aGVybWFubkBncmFmLmF0OnRlc3R0ZXN0\&#39; or token based authentication with appropriate UUID, e.g. \&#39;Token e7372c59-b1e6-4fcd-b5c3-ac4321591b88\&#39;
         * @param {string} [xIdentityManagementTenant] The clients tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyCreateSession(authorization: string, xIdentityManagementTenant?: string, options?: any): AxiosPromise<SessionsResponse> {
            return LegacyApiFp(configuration).legacyCreateSession(authorization, xIdentityManagementTenant, options).then((request) => request(axios, basePath));
        },
        /**
         * Create session for an identity
         * @summary Create session
         * @param {BasicAuth} authorization Base64 encoded credentials, e.g. \&#39;Basic aGVybWFubkBncmFmLmF0OnRlc3R0ZXN0\&#39; or token based authentication with appropriate UUID, e.g. \&#39;Token e7372c59-b1e6-4fcd-b5c3-ac4321591b88\&#39;
         * @param {string} [xIdentityManagementTenant] The clients tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyCreateSessionV2(authorization: BasicAuth, xIdentityManagementTenant?: string, options?: any): AxiosPromise<SessionsResponse> {
            return LegacyApiFp(configuration).legacyCreateSessionV2(authorization, xIdentityManagementTenant, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete session of an identity
         * @summary Delete session
         * @param {string} sessionToken UUID of session
         * @param {string} [xIdentityManagementTenant] The clients tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyDeleteSession(sessionToken: string, xIdentityManagementTenant?: string, options?: any): AxiosPromise<void> {
            return LegacyApiFp(configuration).legacyDeleteSession(sessionToken, xIdentityManagementTenant, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user data by ssoId
         * @summary Get user data by ssoId
         * @param {string} callback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyGetUser(callback: string, options?: any): AxiosPromise<string> {
            return LegacyApiFp(configuration).legacyGetUser(callback, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user data by ssoId
         * @summary Get user data by ssoId
         * @param {string} callback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyGetUser2(callback: string, options?: any): AxiosPromise<string> {
            return LegacyApiFp(configuration).legacyGetUser2(callback, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user data by ssoId
         * @summary Get user data by ssoId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyGetUser3(options?: any): AxiosPromise<PortalApiUser> {
            return LegacyApiFp(configuration).legacyGetUser3(options).then((request) => request(axios, basePath));
        },
        /**
         * performs login with credentials from header
         * @summary Login with given credentials
         * @param {string} authorization Base64 encoded credentials, e.g. \&#39;Basic aGVybWFubkBncmFmLmF0OnRlc3R0ZXN0\&#39; or token based authentication with appropriate UUID, e.g. \&#39;Token e7372c59-b1e6-4fcd-b5c3-ac4321591b88\&#39;
         * @param {boolean} [rememberMe] include rememberMeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyLogin(authorization: string, rememberMe?: boolean, options?: any): AxiosPromise<PortalApiUser> {
            return LegacyApiFp(configuration).legacyLogin(authorization, rememberMe, options).then((request) => request(axios, basePath));
        },
        /**
         * Logout by given ssoId
         * @summary Logout by given ssoId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyLogout(options?: any): AxiosPromise<void> {
            return LegacyApiFp(configuration).legacyLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * Read session from Identity Management
         * @summary Read session
         * @param {string} sessionToken UUID of session
         * @param {string} [xIdentityManagementTenant] The clients tenant identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyReadSession(sessionToken: string, xIdentityManagementTenant?: string, options?: any): AxiosPromise<SessionsResponse> {
            return LegacyApiFp(configuration).legacyReadSession(sessionToken, xIdentityManagementTenant, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the cknr by ssoId
         * @summary Read session for cknr
         * @param {string} sessionToken UUID of session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyReadSessionPnr(sessionToken: string, options?: any): AxiosPromise<string> {
            return LegacyApiFp(configuration).legacyReadSessionPnr(sessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the userId by ssoId
         * @summary Read session for userId
         * @param {string} sessionToken UUID of session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legacyReadSessionUserId(sessionToken: string, options?: any): AxiosPromise<string> {
            return LegacyApiFp(configuration).legacyReadSessionUserId(sessionToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegacyApi - object-oriented interface
 * @export
 * @class LegacyApi
 * @extends {BaseAPI}
 */
export class LegacyApi extends BaseAPI {
    /**
     * Read user by identityKey
     * @summary Read user by identityKey
     * @param {string} identityKey UUID of a user\&#39;s identity
     * @param {string} xIdentityManagementTenant The clients tenant identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public getUserByIdentityKey(identityKey: string, xIdentityManagementTenant: string, options?: any) {
        return LegacyApiFp(this.configuration).getUserByIdentityKey(identityKey, xIdentityManagementTenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a user by ssoId
     * @summary Get a user by ssoId
     * @param {string} ssoId ssoId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public getUserBySsoId(ssoId: string, options?: any) {
        return LegacyApiFp(this.configuration).getUserBySsoId(ssoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create session for an identity
     * @summary Create session
     * @param {string} authorization Base64 encoded credentials, e.g. \&#39;Basic aGVybWFubkBncmFmLmF0OnRlc3R0ZXN0\&#39; or token based authentication with appropriate UUID, e.g. \&#39;Token e7372c59-b1e6-4fcd-b5c3-ac4321591b88\&#39;
     * @param {string} [xIdentityManagementTenant] The clients tenant identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public legacyCreateSession(authorization: string, xIdentityManagementTenant?: string, options?: any) {
        return LegacyApiFp(this.configuration).legacyCreateSession(authorization, xIdentityManagementTenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create session for an identity
     * @summary Create session
     * @param {BasicAuth} authorization Base64 encoded credentials, e.g. \&#39;Basic aGVybWFubkBncmFmLmF0OnRlc3R0ZXN0\&#39; or token based authentication with appropriate UUID, e.g. \&#39;Token e7372c59-b1e6-4fcd-b5c3-ac4321591b88\&#39;
     * @param {string} [xIdentityManagementTenant] The clients tenant identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public legacyCreateSessionV2(authorization: BasicAuth, xIdentityManagementTenant?: string, options?: any) {
        return LegacyApiFp(this.configuration).legacyCreateSessionV2(authorization, xIdentityManagementTenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete session of an identity
     * @summary Delete session
     * @param {string} sessionToken UUID of session
     * @param {string} [xIdentityManagementTenant] The clients tenant identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public legacyDeleteSession(sessionToken: string, xIdentityManagementTenant?: string, options?: any) {
        return LegacyApiFp(this.configuration).legacyDeleteSession(sessionToken, xIdentityManagementTenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user data by ssoId
     * @summary Get user data by ssoId
     * @param {string} callback 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public legacyGetUser(callback: string, options?: any) {
        return LegacyApiFp(this.configuration).legacyGetUser(callback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user data by ssoId
     * @summary Get user data by ssoId
     * @param {string} callback 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public legacyGetUser2(callback: string, options?: any) {
        return LegacyApiFp(this.configuration).legacyGetUser2(callback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user data by ssoId
     * @summary Get user data by ssoId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public legacyGetUser3(options?: any) {
        return LegacyApiFp(this.configuration).legacyGetUser3(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * performs login with credentials from header
     * @summary Login with given credentials
     * @param {string} authorization Base64 encoded credentials, e.g. \&#39;Basic aGVybWFubkBncmFmLmF0OnRlc3R0ZXN0\&#39; or token based authentication with appropriate UUID, e.g. \&#39;Token e7372c59-b1e6-4fcd-b5c3-ac4321591b88\&#39;
     * @param {boolean} [rememberMe] include rememberMeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public legacyLogin(authorization: string, rememberMe?: boolean, options?: any) {
        return LegacyApiFp(this.configuration).legacyLogin(authorization, rememberMe, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Logout by given ssoId
     * @summary Logout by given ssoId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public legacyLogout(options?: any) {
        return LegacyApiFp(this.configuration).legacyLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read session from Identity Management
     * @summary Read session
     * @param {string} sessionToken UUID of session
     * @param {string} [xIdentityManagementTenant] The clients tenant identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public legacyReadSession(sessionToken: string, xIdentityManagementTenant?: string, options?: any) {
        return LegacyApiFp(this.configuration).legacyReadSession(sessionToken, xIdentityManagementTenant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the cknr by ssoId
     * @summary Read session for cknr
     * @param {string} sessionToken UUID of session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public legacyReadSessionPnr(sessionToken: string, options?: any) {
        return LegacyApiFp(this.configuration).legacyReadSessionPnr(sessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the userId by ssoId
     * @summary Read session for userId
     * @param {string} sessionToken UUID of session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyApi
     */
    public legacyReadSessionUserId(sessionToken: string, options?: any) {
        return LegacyApiFp(this.configuration).legacyReadSessionUserId(sessionToken, options).then((request) => request(this.axios, this.basePath));
    }

}


